module.exports = "/assets/src/client/assets/logo.svg";